// Maaş Ödemeleri (/salary-payment). Excel dosyası Türkçe kalır.
const salaryPayment = {
  page: {
    title: 'Maaş Ödemeleri',
    subtitle: '{{period}} dönemi: çalışanların güncel maaşları, ödeme durumu ve toplu ödeme.',
  },
  actions: {
    excel: 'Tabloyu İndir',
    excelHint: 'Maaş listesini Excel olarak indir',
    bulk: 'Toplu Maaş Öde ({{count}})',
    bulkHint: '{{period}} dönemi ödenmemiş maaşları önizleyip öde',
  },
  stats: {
    total: 'Toplam Maaş Kaydı',
    totalShort: 'Kayıt',
    paid: 'Ödenen Maaş',
    paidShort: 'Ödenen',
    unpaid: 'Ödenmemiş Maaş',
    unpaidShort: 'Ödenmemiş',
    toPay: 'Ödenecek Net Tutar',
    toPayShort: 'Ödenecek',
    share: 'Kayıtların %{{percent}}’i',
  },
  toolbar: {
    search: 'İsim veya soyisim ile ara…',
    searchShort: 'Çalışan ara…',
    status: 'Ödeme durumu',
    paid_all: 'Tümü',
    paid_true: 'Ödendi',
    paid_false: 'Ödenmedi',
    month: 'Ödeme dönemi',
    currentMonth: 'Güncel aya dön',
  },
  status: {
    paid: 'Ödendi',
    unpaid: 'Ödenmedi',
  },
  columns: {
    employeeName: 'İsim',
    employeeSurname: 'Soyisim',
    isCurrentMonthPaid: 'Ödeme Durumu',
    lastPaymentDate: 'Son Ödeme Tarihi',
    grossSalary: 'Brüt Ücret',
    sskEmployeeShare: 'SGK İşçi Payı (%14)',
    unemploymentEmployeeShare: 'İşsizlik Sig. İşçi Payı (%1)',
    stampTax: 'Damga Vergisi',
    totalDeductions: 'Kesintiler Toplamı',
    netSalary: 'Net Ücret',
    sskEmployerShare: 'SGK İşveren Payı (%15.5)',
    unemploymentEmployerShare: 'İşsizlik Sig. İşveren Payı (%2)',
    suggestedCost: 'Toplam Maliyet',
    contractDate: 'Sözleşme Tarihi',
  },
  table: {
    listLabel: 'Maaş kayıtları',
    empty: 'Filtrelere uygun maaş kaydı bulunamadı',
    rangeOf: '/ {{total}} kayıt',
    ofTotal: 'toplam {{total}} kayıt içinden',
    jump: 'Sayfaya git',
  },
  card: {
    net: 'Net ücret',
    paidOn: '{{date}} ödendi',
  },
  panel: {
    label: 'Seçili maaş',
    heading: '{{period}}',
    netMonthly: 'Net {{amount}}',
    pay: 'Maaş Öde',
    reverse: 'Geri Al',
    edit: 'Düzenle',
    delete: 'Sil',
    thisMonth: 'Bu dönemin ödemesi',
    paidOn: '{{date}} tarihinde ödendi',
    paidAmount: 'Ödenen net tutar',
    amounts: 'Tutarlar',
    history: 'Ödeme geçmişi',
    noHistory: 'Henüz ödeme yapılmamış.',
  },
  bulk: {
    title: 'Toplu Maaş Ödeme Önizleme',
    subtitle: '{{period}} dönemi',
    count: 'Ödenecek Çalışan',
    totalNet: 'Toplam Net Ödeme',
    totalCost: 'Toplam Maliyet',
    note: 'Ek ödeme ve ek kesinti net ücrete yansır. “Yol Öde” herkese aynı ek ödemeyi yazar.',
    cardLine: 'Brüt {{gross}} · Kesinti {{deductions}}',
    total: 'Toplam',
    columns: {
      employee: 'Çalışan',
      grossSalary: 'Brüt Maaş',
      totalDeductions: 'Kesintiler',
      additionalPayment: 'Ek Ödeme',
      additionalDeduction: 'Ek Kesinti',
      netSalary: 'Net Maaş',
      totalEmployerCost: 'Toplam Maliyet',
    },
    yolOde: 'Yol Öde',
    confirm: 'Ödemeyi Onayla ve Tamamla',
  },
  yol: {
    title: 'Yol Ücreti Belirleme',
    subtitle: 'Tüm çalışanlara ek ödeme olarak eklenir',
    amount: 'Yol ücreti ne kadar olacak?',
    placeholder: 'Tutar giriniz…',
    hint: 'Önizlemedeki {{count}} çalışanın ek ödemesi bu tutar olur.',
    apply: 'Uygula',
  },
  confirm: {
    reverseTitle: 'Ödeme geri alınsın mı?',
    reverseMessage: '{{name}} adlı çalışanın {{period}} dönemi maaş ödemesini geri almak istediğinize emin misiniz?',
    deleteTitle: 'Maaş kaydı silinsin mi?',
    deleteMessage: '{{name}} adlı çalışanın güncel maaş kaydı ve bu kayda bağlı ödeme geçmişi kalıcı olarak silinecek.',
  },
  common: {
    cancel: 'İptal',
  },
  toast: {
    loadError: 'Maaş bilgileri alınırken bir hata oluştu',
    nothingToPay: 'Bu ay için ödenecek maaş bulunmuyor',
    bulkPaid: '{{count}} çalışanın maaş ödemesi tamamlandı',
    paid: '{{name}} adlı çalışanın maaş ödemesi tamamlandı',
    alreadyPaid: '{{name}} adlı çalışanın bu ayki maaşı zaten ödenmiş',
    notPaid: '{{name}} adlı çalışanın bu ayki maaşı zaten ödenmemiş',
    payError: 'Ödeme sırasında bir hata oluştu',
    reversed: '{{name}} adlı çalışanın maaş ödemesi geri alındı',
    reverseError: 'Ödeme geri alınırken bir hata oluştu',
    deleted: 'Maaş başarıyla silindi',
    deleteError: 'Maaş silinirken bir hata oluştu',
    pageJumpInvalid: 'Lütfen 1 ile {{max}} arasında bir sayfa numarası girin.',
  },
};

export default salaryPayment;
